import { render, staticRenderFns } from "./oilRecoveryBackMoney.vue?vue&type=template&id=02528ca0&scoped=true"
import script from "./oilRecoveryBackMoney.vue?vue&type=script&lang=js"
export * from "./oilRecoveryBackMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02528ca0",
  null
  
)

export default component.exports